// libs
import React from 'react';
import AuthService from '../../../../../services/AuthService';
// components
import SystemErrorMessage from "../../../../../components/SystemErrorMessage/index";
import LoadingSpinner from "../../../../../components/LoadingSpinner/index";

const Promotions = (props) => {
    const {
        member,
        promotions,
        isLoading,
        error,
        message
    } = props;

    return (
        AuthService.can('Promotions') &&
            <div className="margin--30--bot relative">
                <h3 className="sub-title margin--10--bot">Promotions</h3>
                {!isLoading && error === null && message &&
                <div
                    className="alert alert--outline alert--success text--center margin--10--bot">{message}</div>}
                {error &&
                <SystemErrorMessage message={error} notified={false}/>}
                <ul className="list--box list--info loading--inline">
                    {promotions}
                    {member.email === '' && promotions.length === 0 && <li>
                        <p>Promotions unavailable as member does not have an email
                            address.</p>
                    </li>}
                    {isLoading && <LoadingSpinner isVisible={true}/>}
                </ul>
            </div>
    );
};

export default Promotions;
